// extracted by mini-css-extract-plugin
export default {"controls":"ProjectGenerationPanel_controls__FfUJB"};